import axios from 'axios'
const { REACT_APP_API_BASE_URL } = process.env

const availabilityCheck = ( transactionId: string ) => {
    const url = `${REACT_APP_API_BASE_URL}/vehicle/${transactionId}/availability`;
    return axios.post(url);
}
export default availabilityCheck

